import { NgModule } from "@angular/core";
import { MatTableResponsiveDirective } from "./mat-table-responsive.directive";

@NgModule({
  declarations: [MatTableResponsiveDirective],
  exports: [MatTableResponsiveDirective]
})
export class MatTableResponsiveModule {}